import React, { Component, forwardRef, Fragment } from "react";
import { styled } from "@mui/material/styles";
import PropTypes from "prop-types";
import PaletteIcon from "@mui/icons-material/Palette";
import IconButton from "@mui/material/IconButton";
import Popover from "@mui/material/Popover";
import Tooltip from "@mui/material/Tooltip";
import ColorPicker from "~/components/ColorPicker/ColorPicker";

const ColorPickerComponent = forwardRef((props, ref) => <ColorPicker {...props} ref={ref} />);

ColorPickerComponent.displayName = "ColorPicker";

const anchorOrigin = { horizontal: "left", vertical: "bottom" };

const Triangle = styled("div")`
  width: 0;
  height: 0;
  border-bottom: 8px solid rgba(0, 0, 0, 0.54);
  border-left: 8px solid transparent;
  position: absolute;
  bottom: 6px;
  right: 6px;
`;

const StyledIconButton = styled(IconButton)(({ theme }) => {
  return {
    "&:focus-visible": {
      outline: theme.outline(),
      outlineOffset: "-2px"
    }
  };
});

class ColorPickerButton extends Component {
  state = {
    anchorEl: null
  };

  constructor(props) {
    super(props);

    this.onOpen = this.onOpen.bind(this);
    this.onClose = this.onClose.bind(this);
    this.onColorPickerChange = this.onColorPickerChange.bind(this);
    this.onStrokeWidthChange = this.onStrokeWidthChange.bind(this);
  }

  onOpen(event) {
    this.setState({
      anchorEl: event.currentTarget
    });
  }

  onClose() {
    this.setState({
      anchorEl: null
    });
  }

  onColorPickerChange(color) {
    this.props.setSelectionColorObject(color.rgb);
    this.props.setPrimaryColorObject(color.rgb);
  }

  onStrokeWidthChange(strokeWidth) {
    this.props.setStrokeWidth(strokeWidth);
    this.props.setSelectionStrokeWidth(strokeWidth);
  }

  render() {
    const { selectionColor, primaryColor, selectionStrokeWidth, strokeWidth } = this.props;
    const { anchorEl } = this.state;

    return (
      <>
        <Tooltip title="Farbauswahl / Strichstärke">
          <StyledIconButton onClick={this.onOpen} size="large" aria-label="Farbauswahl / Strichstärke">
            <PaletteIcon />
            <Triangle />
          </StyledIconButton>
        </Tooltip>
        <Popover open={Boolean(anchorEl)} anchorEl={anchorEl} onClose={this.onClose} anchorOrigin={anchorOrigin}>
          <ColorPickerComponent
            color={selectionColor || primaryColor}
            strokeWidth={selectionStrokeWidth || strokeWidth}
            onStrokeWidthChange={this.onStrokeWidthChange}
            onChangeComplete={this.onColorPickerChange}
          />
        </Popover>
      </>
    );
  }
}

ColorPickerButton.propTypes = {
  primaryColor: PropTypes.object,
  selectionColor: PropTypes.object,
  setPrimaryColorObject: PropTypes.func.isRequired,
  setSelectionColorObject: PropTypes.func.isRequired,
  selectionStrokeWidth: PropTypes.number,
  strokeWidth: PropTypes.number.isRequired,
  setStrokeWidth: PropTypes.func.isRequired,
  setSelectionStrokeWidth: PropTypes.func.isRequired
};

export default ColorPickerButton;
